import { Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';

import { WebApiModel } from '../../../models/web-api.model';
import { RouterHelperService } from '../../../services/router-helper.service';
import { SettingsService } from '../../../services/settings.service';

@Component({
  selector: 'hcf-place-detail',
  templateUrl: './place-detail.component.html',
  styleUrls: ['./place-detail.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class PlaceDetailComponent implements OnChanges {
  @Input() placeDetail: WebApiModel.Place;
  @Input() serviceCategoryName: string;

  placeLink: any[];
  services: string[];
  settings = SettingsService;

  ngOnChanges() {
    const id = this.placeDetail.id;
    const routeType = RouterHelperService.routeType.placeProfile;
    const route = RouterHelperService.getRoute(routeType, id, this.placeDetail.practiceName, null);
    this.placeLink = route.link;
    // Get services
    this.placeDetail.serviceCategories.forEach((category) => {
      if (category.name === this.serviceCategoryName) {
        // Filter null or empty
        this.services = category.services.filter((serviceName) => {
          return !!serviceName; // Explicitly return true or false
        });
      }
    });
  }
}
